import React from 'react';
import { Document, Page } from '@react-pdf/renderer';
import { VendorCatalogSamplePageContent } from './VendorCatalogSamplePDF';
import { styles } from './styles';

import { SampleTagResponse } from '../types';

/**
 * Combined PDF component that renders multiple sample tags in a single PDF document
 * Each tag gets its own page
 *
 * All tags from "Sell To Us" are vendor catalog items, so we use VendorCatalogSamplePageContent
 */
export function CombinedSampleTagsPDF({ tags }: { tags: SampleTagResponse[] }) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Document>
      {tags.map((tag) => (
        <Page
          key={tag.id || tag.sample_tag_lpn}
          size="LETTER"
          style={styles.page}
        >
          <VendorCatalogSamplePageContent tagData={tag} />
        </Page>
      ))}
    </Document>
  );
}
